import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { ArrowRight, Heart } from 'lucide-react';

export function CTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section ref={ref} className="py-20 lg:py-28 bg-p-600">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="max-w-3xl"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4 leading-tight">
            Build a Structured Waste Management System.
          </h2>
          <p className="text-p-100 text-lg mb-10">
            Efficient waste management improves compliance, recovery value, and sustainability
            performance. Partner with Punarvaa to transform waste into measurable resource value.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Link
              to="/contact?audit=true"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white text-p-700 text-sm font-semibold rounded-md hover:bg-p-50 transition-colors"
            >
              Request Waste Assessment
              <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/contact?quote=true"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-white/40 text-white text-sm font-semibold rounded-md hover:bg-white/10 transition-colors"
            >
              Schedule Consultation
            </Link>
            <Link
              to="/contact?proposal=true"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-white/40 text-white text-sm font-semibold rounded-md hover:bg-white/10 transition-colors"
            >
              Get Service Proposal
            </Link>
          </div>

          {/* Donate section */}
          <div className="border-t border-p-500 pt-8">
            <div className="flex items-start gap-3">
              <Heart className="w-5 h-5 text-p-200 shrink-0 mt-0.5" />
              <div>
                <p className="text-white font-semibold mb-1">Donate Your Waste</p>
                <p className="text-p-100 text-sm mb-3">
                  Want to donate old garments, toys, e-waste, or other materials? We'll ensure
                  responsible recovery and recycling.
                </p>
                <Link
                  to="/contact?donate=true"
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-white underline underline-offset-2 hover:text-p-100 transition-colors"
                >
                  Donate your waste →
                </Link>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
